module.exports = __webpack_public_path__ + "static/img/genre_03.fc60960.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/company/genre_03.png
// module id = EOwN
// module chunks = 0